 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		"app": 0
 	}

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"app": 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "js/" + ({"stencil-polyfills-css-shim":"stencil-polyfills-css-shim","stencil-polyfills-dom":"stencil-polyfills-dom"}[chunkId]||chunkId) + "." + {"chunk-1f1a5972":"90245289","chunk-29f3e6e1":"daa67081","chunk-2a1b470e":"aaba5fab","chunk-2b3cf397":"0e14165f","chunk-07b207e8":"7fa29b19","chunk-1ad67f3b":"c9b7f739","chunk-3c659841":"ae32223c","chunk-599007dc":"96a4e098","chunk-686fe9ff":"351e3c0d","chunk-350ba5da":"ef2990ca","chunk-932096ae":"1ef83df6","chunk-686314ee":"3cb3ad9b","chunk-65a24634":"6100ac5d","chunk-690f0484":"d78add02","chunk-043a3d04":"6e16b77b","chunk-afa69e4c":"bd44675c","chunk-e5101fba":"d33dc843","chunk-2070a28e":"87e2baac","chunk-2d0a43c3":"b7974701","chunk-2d0ac931":"cc71baa3","chunk-2d0c211b":"56bba833","chunk-2d0cf315":"c8f5219d","chunk-2d0e2170":"5a3fb417","chunk-2d208e4e":"07eef6b7","chunk-2d212be3":"2b736999","chunk-2d217def":"9b86ebe8","chunk-2d21a9aa":"bdd6764c","chunk-2d222cca":"4226e9f6","chunk-2d22895d":"4ebcf334","chunk-2d23721e":"7970ea5d","chunk-31702efe":"90a1fab3","chunk-38e2a829":"ee13f863","chunk-6c7157f6":"e8802eed","chunk-c27c1ee8":"aa3b6743","chunk-3e0799e4":"e482c5cd","chunk-41a21820":"f99b48ea","chunk-45ffaafd":"e7b39e54","chunk-2d0e6c6b":"a11e93ec","chunk-501d61ae":"925f66d8","chunk-565dcac2":"609b5656","chunk-571ca999":"7c8755ea","chunk-59d6bc00":"d01bcce2","chunk-6da76915":"954df9a0","chunk-dac05008":"2c1bcd7e","chunk-6097853c":"1487db90","chunk-bfabe0ae":"5aa9b0a9","chunk-c3c185d6":"db8ff13d","chunk-c8ed6310":"430b770c","stencil-polyfills-css-shim":"b85f8bdc","stencil-polyfills-dom":"6e9caa76","chunk-7420a3b0":"b7dbd8ee","chunk-6d48844a":"138cb634","chunk-fe9d84cc":"6397f0c7","chunk-4834972e":"16da398d","chunk-89fb59a8":"984f899f","chunk-2d0c7af3":"6091e29c","chunk-2d0c8407":"d288f729","chunk-3af19782":"0640c67b","chunk-3c4483fb":"145123fd","chunk-84af7e66":"84147807","chunk-ac1b6934":"09ed9e98","chunk-1901a988":"f95cba99","chunk-5be5bfc1":"e8ed7cfb","chunk-5fc5ab98":"78959b6f","chunk-a09c1f8a":"100e2668","chunk-1dc74f47":"30f29cc1","chunk-cb5cd53e":"0832f079","chunk-363320c0":"86e6083e","chunk-ef4328e0":"ea22e10e","chunk-0cc1ee88":"15e0e89c","chunk-46bfc546":"36cc695d","chunk-20e32000":"f91e41d7","chunk-1bf5ebaa":"79e6ed7b","chunk-d46ee89c":"0b82aa28","chunk-76faa9ce":"d0aaa74e","chunk-c68f878a":"480e2c62","chunk-5af9bc0e":"580fef7b","chunk-2d0c1d9a":"e0963d80","chunk-6c36bfab":"8db6cac3","chunk-94d25c66":"3bce1a84","chunk-045460df":"0aee22c8","chunk-0d7d582a":"fc90db59","chunk-2d0cc074":"506137fb","chunk-2d216280":"839bdfd7","chunk-42f06979":"826c33ce","chunk-a0cf06aa":"7e7d2a39","chunk-2d20f3b3":"6df03b16","chunk-7962b45d":"fb6b49eb","chunk-1830d239":"a000254f","chunk-44252172":"7acad34f","chunk-ac411f70":"c363b474","chunk-2d216786":"558bb5ce","chunk-2d0a4f60":"0a14b930","chunk-2d0ab819":"6fd3c6a9","chunk-2d0b21f3":"b3494a99","chunk-2d0cc9d8":"0316a235","chunk-2d0d70b7":"b156b2b2","chunk-2d2093c1":"9fc0e361","chunk-2d2100cb":"0a9c3194","chunk-2d2169b9":"75362efe","chunk-2d216d7a":"26452da4","chunk-2d216f1a":"6071cce7","chunk-2d2214fd":"c104bb88","chunk-2d22493e":"454859e9","chunk-2d229999":"d96c55d4","chunk-7736c7e4":"ae97fb97","chunk-2d0ea110":"c0c135eb","chunk-2d2214f1":"4602e7eb"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"chunk-1f1a5972":1,"chunk-29f3e6e1":1,"chunk-2a1b470e":1,"chunk-2b3cf397":1,"chunk-07b207e8":1,"chunk-1ad67f3b":1,"chunk-3c659841":1,"chunk-599007dc":1,"chunk-686fe9ff":1,"chunk-350ba5da":1,"chunk-932096ae":1,"chunk-686314ee":1,"chunk-65a24634":1,"chunk-690f0484":1,"chunk-043a3d04":1,"chunk-afa69e4c":1,"chunk-e5101fba":1,"chunk-2070a28e":1,"chunk-38e2a829":1,"chunk-6c7157f6":1,"chunk-c27c1ee8":1,"chunk-3e0799e4":1,"chunk-41a21820":1,"chunk-45ffaafd":1,"chunk-501d61ae":1,"chunk-565dcac2":1,"chunk-571ca999":1,"chunk-6da76915":1,"chunk-dac05008":1,"chunk-6097853c":1,"chunk-bfabe0ae":1,"chunk-c3c185d6":1,"chunk-c8ed6310":1,"chunk-7420a3b0":1,"chunk-6d48844a":1,"chunk-fe9d84cc":1,"chunk-4834972e":1,"chunk-89fb59a8":1,"chunk-3af19782":1,"chunk-3c4483fb":1,"chunk-84af7e66":1,"chunk-ac1b6934":1,"chunk-1901a988":1,"chunk-5be5bfc1":1,"chunk-5fc5ab98":1,"chunk-a09c1f8a":1,"chunk-1dc74f47":1,"chunk-cb5cd53e":1,"chunk-363320c0":1,"chunk-ef4328e0":1,"chunk-46bfc546":1,"chunk-20e32000":1,"chunk-1bf5ebaa":1,"chunk-d46ee89c":1,"chunk-76faa9ce":1,"chunk-c68f878a":1,"chunk-5af9bc0e":1,"chunk-6c36bfab":1,"chunk-94d25c66":1,"chunk-045460df":1,"chunk-0d7d582a":1,"chunk-42f06979":1,"chunk-a0cf06aa":1,"chunk-7962b45d":1,"chunk-1830d239":1,"chunk-44252172":1,"chunk-ac411f70":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "css/" + ({"stencil-polyfills-css-shim":"stencil-polyfills-css-shim","stencil-polyfills-dom":"stencil-polyfills-dom"}[chunkId]||chunkId) + "." + {"chunk-1f1a5972":"04adf890","chunk-29f3e6e1":"3a6fb0a5","chunk-2a1b470e":"0d31713b","chunk-2b3cf397":"9790f5e2","chunk-07b207e8":"341611cb","chunk-1ad67f3b":"e25fe3c9","chunk-3c659841":"ec7141b6","chunk-599007dc":"5b3d1b2e","chunk-686fe9ff":"483e6953","chunk-350ba5da":"24e45155","chunk-932096ae":"15b5a788","chunk-686314ee":"218fa183","chunk-65a24634":"f205a3e7","chunk-690f0484":"11cb957a","chunk-043a3d04":"5487b622","chunk-afa69e4c":"341611cb","chunk-e5101fba":"3b156ef3","chunk-2070a28e":"218fa183","chunk-2d0a43c3":"31d6cfe0","chunk-2d0ac931":"31d6cfe0","chunk-2d0c211b":"31d6cfe0","chunk-2d0cf315":"31d6cfe0","chunk-2d0e2170":"31d6cfe0","chunk-2d208e4e":"31d6cfe0","chunk-2d212be3":"31d6cfe0","chunk-2d217def":"31d6cfe0","chunk-2d21a9aa":"31d6cfe0","chunk-2d222cca":"31d6cfe0","chunk-2d22895d":"31d6cfe0","chunk-2d23721e":"31d6cfe0","chunk-31702efe":"31d6cfe0","chunk-38e2a829":"07e99984","chunk-6c7157f6":"626caa8d","chunk-c27c1ee8":"166abf62","chunk-3e0799e4":"d1d7c646","chunk-41a21820":"91916f45","chunk-45ffaafd":"d03f410e","chunk-2d0e6c6b":"31d6cfe0","chunk-501d61ae":"fe39eb1e","chunk-565dcac2":"07e99984","chunk-571ca999":"9d565bef","chunk-59d6bc00":"31d6cfe0","chunk-6da76915":"e64ae09c","chunk-dac05008":"bbc5bc83","chunk-6097853c":"c1668527","chunk-bfabe0ae":"4e7978ed","chunk-c3c185d6":"9957f1e2","chunk-c8ed6310":"ed741d80","stencil-polyfills-css-shim":"31d6cfe0","stencil-polyfills-dom":"31d6cfe0","chunk-7420a3b0":"8a847326","chunk-6d48844a":"bf145334","chunk-fe9d84cc":"c91fe02c","chunk-4834972e":"3ffa6408","chunk-89fb59a8":"0aa84e4a","chunk-2d0c7af3":"31d6cfe0","chunk-2d0c8407":"31d6cfe0","chunk-3af19782":"55392260","chunk-3c4483fb":"626caa8d","chunk-84af7e66":"1b2e1e3a","chunk-ac1b6934":"a22277ac","chunk-1901a988":"3286522e","chunk-5be5bfc1":"91bf4ad8","chunk-5fc5ab98":"33d6148b","chunk-a09c1f8a":"f4f2c1ce","chunk-1dc74f47":"223f9ded","chunk-cb5cd53e":"c884785b","chunk-363320c0":"91916f45","chunk-ef4328e0":"626caa8d","chunk-0cc1ee88":"31d6cfe0","chunk-46bfc546":"193b24e7","chunk-20e32000":"f4f2c1ce","chunk-1bf5ebaa":"539a3286","chunk-d46ee89c":"c20515af","chunk-76faa9ce":"2cf80ca8","chunk-c68f878a":"c884785b","chunk-5af9bc0e":"218fa183","chunk-2d0c1d9a":"31d6cfe0","chunk-6c36bfab":"3a6fb0a5","chunk-94d25c66":"5e8fed02","chunk-045460df":"e3a72982","chunk-0d7d582a":"80b8dbff","chunk-2d0cc074":"31d6cfe0","chunk-2d216280":"31d6cfe0","chunk-42f06979":"dc88a913","chunk-a0cf06aa":"dc88a913","chunk-2d20f3b3":"31d6cfe0","chunk-7962b45d":"95dcbb53","chunk-1830d239":"f1641c2b","chunk-44252172":"8ee1115f","chunk-ac411f70":"1a9f1040","chunk-2d216786":"31d6cfe0","chunk-2d0a4f60":"31d6cfe0","chunk-2d0ab819":"31d6cfe0","chunk-2d0b21f3":"31d6cfe0","chunk-2d0cc9d8":"31d6cfe0","chunk-2d0d70b7":"31d6cfe0","chunk-2d2093c1":"31d6cfe0","chunk-2d2100cb":"31d6cfe0","chunk-2d2169b9":"31d6cfe0","chunk-2d216d7a":"31d6cfe0","chunk-2d216f1a":"31d6cfe0","chunk-2d2214fd":"31d6cfe0","chunk-2d22493e":"31d6cfe0","chunk-2d229999":"31d6cfe0","chunk-7736c7e4":"31d6cfe0","chunk-2d0ea110":"31d6cfe0","chunk-2d2214f1":"31d6cfe0"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// add entry module to deferred list
 	deferredModules.push([0,"chunk-vendors"]);
 	// run deferred modules when ready
 	return checkDeferredModules();
